// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.listas-page[data-v-ccd0a654] {
  --ink: #1b2740;
  --soft: #5c6b86;
  --line: #d5deea;
  --field: #8b97ab;
  --sheet: #f3f6fa;
  --binding: #ff7900;
  --peligro: #9b1c3c;
  margin-top: -0.75rem;
  padding-top: 1.15rem;
  background: #fff;
  color: var(--ink);
}
.listas-formulario[data-v-ccd0a654] {
  max-width: 72rem;
  margin-left: auto;
  margin-right: auto;
}
.listas-cabecera[data-v-ccd0a654] {
  margin-bottom: 1.15rem;
}
.listas-cabecera-fila[data-v-ccd0a654] {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
  margin-top: 1rem;
}
.listas-formulario #seccionCabecera .listas-title-row[data-v-ccd0a654] {
  margin-top: 0;
}

/* Las dos etiquetas comparten celda: el botón mide siempre lo que la más larga. */
.listas-alta-toggle-textos[data-v-ccd0a654] {
  display: inline-grid;
}
.listas-alta-toggle-textos > span[data-v-ccd0a654] {
  grid-area: 1 / 1;
  text-align: center;
}
.listas-alta-toggle-textos > .es-oculto[data-v-ccd0a654] {
  visibility: hidden;
}
.listas-formulario .listas-alta-toggle[data-v-ccd0a654] {
  flex: 0 0 auto;
  margin-top: -0.15rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.9rem;
  border: 1px solid var(--ink);
  border-radius: 4px;
  background: var(--ink);
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.16s ease, color 0.16s ease;
}
.listas-formulario .listas-alta-toggle[data-v-ccd0a654]:hover {
  background: #121a2c;
  border-color: #121a2c;
  color: #fff;
}
.listas-formulario .listas-alta-toggle.abierta[data-v-ccd0a654] {
  background: #fff;
  color: var(--ink);
}
.listas-formulario .listas-alta-toggle.abierta[data-v-ccd0a654]:hover {
  background: var(--sheet);
  border-color: var(--ink);
  color: var(--ink);
}
.listas-alta-toggle-icono[data-v-ccd0a654] {
  font-size: 0.8rem;
  transition: transform 0.2s ease;
}
.listas-alta-toggle.abierta .listas-alta-toggle-icono[data-v-ccd0a654] {
  transform: rotate(45deg);
}

/* Cerrado, el panel no ocupa sitio ni entra en el orden de tabulación. */
.listas-alta-panel[data-v-ccd0a654] {
  display: grid;
  grid-template-rows: 0fr;
  visibility: hidden;
  transition: grid-template-rows 0.25s ease, visibility 0s linear 0.25s;
}
.listas-alta-panel.abierta[data-v-ccd0a654] {
  grid-template-rows: 1fr;
  visibility: visible;
  transition: grid-template-rows 0.25s ease, visibility 0s;
}
.listas-alta-panel-interior[data-v-ccd0a654] {
  min-height: 0;
  overflow: hidden;
}
.listas-alta-panel .listas-sheet[data-v-ccd0a654] {
  margin-bottom: 0.4rem;
}
.listas-formulario #seccionCabecera p[data-v-ccd0a654] {
  text-align: left;
  padding-left: 0;
  margin-bottom: 0;
}
.listas-title[data-v-ccd0a654] {
  display: block;
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.05;
  color: var(--ink);
}
.listas-title[data-v-ccd0a654]::after {
  content: "";
  display: block;
  width: 2.25rem;
  height: 3px;
  margin-top: 0.55rem;
  background: var(--binding);
}
.listas-lead[data-v-ccd0a654] {
  margin-top: 0.55rem;
  color: var(--soft);
  font-size: 0.95rem;
}
.listas-sheet[data-v-ccd0a654] {
  background: var(--sheet);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 1.1rem 1.2rem 1.05rem;
}
.listas-roster[data-v-ccd0a654] {
  margin-top: 0.85rem;
}
.listas-bloque-titulo[data-v-ccd0a654],
.listas-anadir-titulo[data-v-ccd0a654] {
  margin: 0 0 0.7rem;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--ink);
}
.listas-alta-grid[data-v-ccd0a654],
.listas-anadir-grid[data-v-ccd0a654] {
  display: grid;
  gap: 0.75rem 1rem;
  align-items: end;
}
.listas-alta-grid[data-v-ccd0a654] {
  grid-template-columns: minmax(0, 1fr) auto;
}
.listas-alta-grid.con-origen[data-v-ccd0a654] {
  grid-template-columns: minmax(11rem, 16rem) minmax(0, 1fr) auto;
}
.listas-anadir-grid[data-v-ccd0a654] {
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr) minmax(0, 1.25fr) auto;
}
.listas-field[data-v-ccd0a654] {
  margin-bottom: 0;
  min-width: 0;
}
.listas-formulario[data-v-ccd0a654] .form-label {
  margin-bottom: 0.3rem;
  color: var(--ink);
  font-size: 0.82rem;
  font-weight: 600;
}
.listas-formulario[data-v-ccd0a654] .form-control,
.listas-formulario[data-v-ccd0a654] .form-select {
  border-color: var(--field);
  border-radius: 4px;
  color: var(--ink);
}
.listas-formulario[data-v-ccd0a654] .form-control:focus,
.listas-formulario[data-v-ccd0a654] .form-select:focus {
  border-color: var(--ink);
  box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);
}
.listas-avisos[data-v-ccd0a654] {
  margin-top: 0.85rem;
}
.listas-formulario[data-v-ccd0a654] .alert {
  border-radius: 4px;
  font-size: 0.9rem;
}
.listas-vacio[data-v-ccd0a654] {
  margin: 0.9rem 0 0;
  color: var(--soft);
  font-size: 0.95rem;
}
.listas-roster-head[data-v-ccd0a654] {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
  margin-bottom: 0.85rem;
}
.listas-roster-identidad[data-v-ccd0a654] {
  flex: 1 1 auto;
  min-width: 0;
}
.listas-renombrar[data-v-ccd0a654] {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.65rem;
}
.listas-formulario[data-v-ccd0a654] .listas-nombre-lista.form-control {
  flex: 0 1 auto;
  width: auto;
  min-width: 8rem;
  max-width: 100%;
  field-sizing: content;
  height: auto;
  padding: 0.1rem 0.35rem 0.2rem 0;
  border: 0;
  border-bottom: 1px solid transparent;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: 1.55rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--ink);
}
.listas-formulario[data-v-ccd0a654] .listas-nombre-lista.form-control:hover {
  border-bottom-color: var(--line);
}
.listas-formulario[data-v-ccd0a654] .listas-nombre-lista.form-control:focus {
  border-bottom-color: var(--ink);
  background: transparent;
  box-shadow: none;
  outline: 2px solid var(--ink);
  outline-offset: 3px;
}
.listas-cuenta[data-v-ccd0a654] {
  margin: 0.2rem 0 0;
  color: var(--soft);
  font-size: 0.8rem;
}
.listas-tabla-wrap[data-v-ccd0a654] {
  overflow-x: auto;
}
.listas-tabla[data-v-ccd0a654] {
  width: 100%;
  border-collapse: collapse;
}
.listas-tabla th[data-v-ccd0a654] {
  padding: 0 0.4rem 0.4rem;
  border-bottom: 1px solid var(--line);
  color: var(--soft);
  font-size: 0.75rem;
  font-weight: 600;
  text-align: left;
}
.listas-tabla th.listas-th-accion[data-v-ccd0a654] {
  text-align: right;
  white-space: nowrap;
}
.listas-tabla td[data-v-ccd0a654] {
  padding: 0.45rem 0.4rem 0.2rem;
  vertical-align: bottom;
  border: 0;
}
.listas-nadie[data-v-ccd0a654] {
  padding: 0.85rem 0.4rem;
  color: var(--soft);
  font-size: 0.9rem;
}
.listas-formulario[data-v-ccd0a654] .listas-quiet.form-control {
  border-width: 0 0 2px;
  border-style: solid;
  border-color: var(--field);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
}
.listas-formulario[data-v-ccd0a654] .listas-quiet.form-control:hover {
  border-bottom-color: var(--ink);
  background: transparent;
}
.listas-formulario[data-v-ccd0a654] .listas-quiet.form-control:focus {
  border-bottom-color: var(--ink);
  background: #fff;
  box-shadow: none;
  outline: none;
}
.listas-formulario[data-v-ccd0a654] .listas-quiet.form-control:-webkit-autofill,
.listas-formulario[data-v-ccd0a654] .listas-quiet.form-control:-webkit-autofill:hover {
  -webkit-text-fill-color: var(--ink);
  caret-color: var(--ink);
  box-shadow: 0 0 0 1000px #fff inset;
  transition: background-color 9999s ease-out;
}
.listas-acciones[data-v-ccd0a654] {
  display: flex;
  gap: 0.4rem;
  justify-content: flex-end;
}
.listas-anadir[data-v-ccd0a654] {
  margin-top: 0.95rem;
  padding-top: 0.9rem;
  border-top: 1px solid var(--line);
}
.listas-formulario[data-v-ccd0a654] .listas-commit.btn {
  background: var(--ink);
  border-color: var(--ink);
  border-radius: 4px;
  color: #fff;
  font-weight: 600;
}
.listas-formulario[data-v-ccd0a654] .listas-commit.btn:hover:not(:disabled) {
  background: #121a2c;
  border-color: #121a2c;
  color: #fff;
}
.listas-formulario[data-v-ccd0a654] .listas-commit.btn:disabled {
  background: #c5cedb;
  border-color: #c5cedb;
  color: #fff;
  opacity: 1;
}
.listas-formulario[data-v-ccd0a654] .listas-peligro.btn {
  background: transparent;
  border-color: #e2c9d1;
  border-radius: 4px;
  color: var(--peligro);
  font-weight: 600;
}
.listas-formulario[data-v-ccd0a654] .listas-peligro.btn:hover:not(:disabled) {
  background: var(--peligro);
  border-color: var(--peligro);
  color: #fff;
}
.listas-formulario[data-v-ccd0a654] .listas-peligro.btn:disabled {
  color: #c4a8b2;
  border-color: #eadde1;
  background: transparent;
  opacity: 1;
}
.listas-formulario[data-v-ccd0a654] .listas-guardar.btn {
  background: transparent;
  border-color: #c5cedb;
  color: var(--ink);
}
.listas-formulario[data-v-ccd0a654] .listas-guardar.btn:hover:not(:disabled) {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}
.listas-formulario[data-v-ccd0a654] .listas-quitar.btn {
  border-color: transparent;
  background: transparent;
}
.listas-formulario[data-v-ccd0a654] .listas-quitar.btn:hover:not(:disabled) {
  background: var(--peligro);
  border-color: var(--peligro);
  color: #fff;
}
.listas-formulario[data-v-ccd0a654] .btn:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}
@media (max-width: 760px) {
.listas-page[data-v-ccd0a654] {
    padding-top: 0.85rem;
    background: #fff;
}
.listas-sheet[data-v-ccd0a654] {
    padding: 0.95rem 0.85rem 0.9rem;
}
.listas-title[data-v-ccd0a654] {
    font-size: 1.7rem;
}
.listas-alta-grid[data-v-ccd0a654],
  .listas-alta-grid.con-origen[data-v-ccd0a654],
  .listas-anadir-grid[data-v-ccd0a654] {
    grid-template-columns: 1fr;
}
.listas-alta-accion[data-v-ccd0a654] .btn,
  .listas-anadir-accion[data-v-ccd0a654] .btn {
    width: 100%;
}
.listas-roster-head[data-v-ccd0a654] {
    flex-direction: column;
}
.listas-formulario[data-v-ccd0a654] .listas-nombre-lista.form-control {
    font-size: 1.35rem;
}
.listas-tabla thead[data-v-ccd0a654] {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
.listas-tabla td[data-label][data-v-ccd0a654]::before {
    content: attr(data-label);
    display: block;
    margin-bottom: 0.15rem;
    color: var(--soft);
    font-size: 0.75rem;
    font-weight: 600;
}
.listas-tabla[data-v-ccd0a654],
  .listas-tabla tbody[data-v-ccd0a654],
  .listas-tabla tr[data-v-ccd0a654],
  .listas-tabla td[data-v-ccd0a654] {
    display: block;
    width: 100%;
}
.listas-tabla tr[data-v-ccd0a654] {
    padding: 0.35rem 0 0.5rem;
    border-bottom: 1px solid var(--line);
}
.listas-tabla td[data-v-ccd0a654] {
    border-bottom: 0;
    padding: 0.2rem 0;
}
.listas-acciones[data-v-ccd0a654] {
    justify-content: flex-start;
    padding-top: 0.35rem;
}
}
@media (prefers-reduced-motion: reduce) {
.listas-alta-panel[data-v-ccd0a654],
  .listas-alta-panel.abierta[data-v-ccd0a654],
  .listas-alta-toggle[data-v-ccd0a654],
  .listas-alta-toggle-icono[data-v-ccd0a654],
  .listas-formulario[data-v-ccd0a654] .form-control,
  .listas-formulario[data-v-ccd0a654] .btn {
    transition: none;
}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ListasDestinatarios.vue"],"names":[],"mappings":";AAikBA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;;AAEA,kFAAkF;AAClF;EACE,oBAAoB;AACtB;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yDAAyD;AAC3D;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;AACnB;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qEAAqE;AACvE;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wDAAwD;AAC1D;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;AAChC;AAEA;EACE,mBAAmB;AACrB;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;EACE,0CAA0C;AAC5C;AAEA;EACE,+DAA+D;AACjE;AAEA;EACE,8EAA8E;AAChF;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;;EAEE,wBAAwB;EACxB,4CAA4C;AAC9C;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;AAEA;EACE,cAAc;EACd,YAAY;AACd;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gCAAgC;EAChC,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,SAAS;AACX;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AAEA;;EAEE,mCAAmC;EACnC,uBAAuB;EACvB,mCAAmC;EACnC,2CAA2C;AAC7C;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;AACZ;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AAEA;AACE;IACE,oBAAoB;IACpB,gBAAgB;AAClB;AAEA;IACE,+BAA+B;AACjC;AAEA;IACE,iBAAiB;AACnB;AAEA;;;IAGE,0BAA0B;AAC5B;AAEA;;IAEE,WAAW;AACb;AAEA;IACE,sBAAsB;AACxB;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACX;AAEA;IACE,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AAClB;AAEA;;;;IAIE,cAAc;IACd,WAAW;AACb;AAEA;IACE,yBAAyB;IACzB,oCAAoC;AACtC;AAEA;IACE,gBAAgB;IAChB,iBAAiB;AACnB;AAEA;IACE,2BAA2B;IAC3B,oBAAoB;AACtB;AACF;AAEA;AACE;;;;;;IAME,gBAAgB;AAClB;AACF","sourcesContent":["\n.listas-page {\n  --ink: #1b2740;\n  --soft: #5c6b86;\n  --line: #d5deea;\n  --field: #8b97ab;\n  --sheet: #f3f6fa;\n  --binding: #ff7900;\n  --peligro: #9b1c3c;\n  margin-top: -0.75rem;\n  padding-top: 1.15rem;\n  background: #fff;\n  color: var(--ink);\n}\n\n.listas-formulario {\n  max-width: 72rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.listas-cabecera {\n  margin-bottom: 1.15rem;\n}\n\n.listas-cabecera-fila {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1.25rem;\n  margin-top: 1rem;\n}\n\n.listas-formulario #seccionCabecera .listas-title-row {\n  margin-top: 0;\n}\n\n/* Las dos etiquetas comparten celda: el botón mide siempre lo que la más larga. */\n.listas-alta-toggle-textos {\n  display: inline-grid;\n}\n\n.listas-alta-toggle-textos > span {\n  grid-area: 1 / 1;\n  text-align: center;\n}\n\n.listas-alta-toggle-textos > .es-oculto {\n  visibility: hidden;\n}\n\n.listas-formulario .listas-alta-toggle {\n  flex: 0 0 auto;\n  margin-top: -0.15rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.9rem;\n  border: 1px solid var(--ink);\n  border-radius: 4px;\n  background: var(--ink);\n  color: #fff;\n  font-weight: 600;\n  white-space: nowrap;\n  transition: background-color 0.16s ease, color 0.16s ease;\n}\n\n.listas-formulario .listas-alta-toggle:hover {\n  background: #121a2c;\n  border-color: #121a2c;\n  color: #fff;\n}\n\n.listas-formulario .listas-alta-toggle.abierta {\n  background: #fff;\n  color: var(--ink);\n}\n\n.listas-formulario .listas-alta-toggle.abierta:hover {\n  background: var(--sheet);\n  border-color: var(--ink);\n  color: var(--ink);\n}\n\n.listas-alta-toggle-icono {\n  font-size: 0.8rem;\n  transition: transform 0.2s ease;\n}\n\n.listas-alta-toggle.abierta .listas-alta-toggle-icono {\n  transform: rotate(45deg);\n}\n\n/* Cerrado, el panel no ocupa sitio ni entra en el orden de tabulación. */\n.listas-alta-panel {\n  display: grid;\n  grid-template-rows: 0fr;\n  visibility: hidden;\n  transition: grid-template-rows 0.25s ease, visibility 0s linear 0.25s;\n}\n\n.listas-alta-panel.abierta {\n  grid-template-rows: 1fr;\n  visibility: visible;\n  transition: grid-template-rows 0.25s ease, visibility 0s;\n}\n\n.listas-alta-panel-interior {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.listas-alta-panel .listas-sheet {\n  margin-bottom: 0.4rem;\n}\n\n.listas-formulario #seccionCabecera p {\n  text-align: left;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.listas-title {\n  display: block;\n  font-size: 2rem;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1.05;\n  color: var(--ink);\n}\n\n.listas-title::after {\n  content: \"\";\n  display: block;\n  width: 2.25rem;\n  height: 3px;\n  margin-top: 0.55rem;\n  background: var(--binding);\n}\n\n.listas-lead {\n  margin-top: 0.55rem;\n  color: var(--soft);\n  font-size: 0.95rem;\n}\n\n.listas-sheet {\n  background: var(--sheet);\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 1.1rem 1.2rem 1.05rem;\n}\n\n.listas-roster {\n  margin-top: 0.85rem;\n}\n\n.listas-bloque-titulo,\n.listas-anadir-titulo {\n  margin: 0 0 0.7rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--ink);\n}\n\n.listas-alta-grid,\n.listas-anadir-grid {\n  display: grid;\n  gap: 0.75rem 1rem;\n  align-items: end;\n}\n\n.listas-alta-grid {\n  grid-template-columns: minmax(0, 1fr) auto;\n}\n\n.listas-alta-grid.con-origen {\n  grid-template-columns: minmax(11rem, 16rem) minmax(0, 1fr) auto;\n}\n\n.listas-anadir-grid {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr) minmax(0, 1.25fr) auto;\n}\n\n.listas-field {\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.listas-formulario :deep(.form-label) {\n  margin-bottom: 0.3rem;\n  color: var(--ink);\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.listas-formulario :deep(.form-control),\n.listas-formulario :deep(.form-select) {\n  border-color: var(--field);\n  border-radius: 4px;\n  color: var(--ink);\n}\n\n.listas-formulario :deep(.form-control:focus),\n.listas-formulario :deep(.form-select:focus) {\n  border-color: var(--ink);\n  box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);\n}\n\n.listas-avisos {\n  margin-top: 0.85rem;\n}\n\n.listas-formulario :deep(.alert) {\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.listas-vacio {\n  margin: 0.9rem 0 0;\n  color: var(--soft);\n  font-size: 0.95rem;\n}\n\n.listas-roster-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1.25rem;\n  margin-bottom: 0.85rem;\n}\n\n.listas-roster-identidad {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.listas-renombrar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem 0.65rem;\n}\n\n.listas-formulario :deep(.listas-nombre-lista.form-control) {\n  flex: 0 1 auto;\n  width: auto;\n  min-width: 8rem;\n  max-width: 100%;\n  field-sizing: content;\n  height: auto;\n  padding: 0.1rem 0.35rem 0.2rem 0;\n  border: 0;\n  border-bottom: 1px solid transparent;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  font-size: 1.55rem;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  color: var(--ink);\n}\n\n.listas-formulario :deep(.listas-nombre-lista.form-control:hover) {\n  border-bottom-color: var(--line);\n}\n\n.listas-formulario :deep(.listas-nombre-lista.form-control:focus) {\n  border-bottom-color: var(--ink);\n  background: transparent;\n  box-shadow: none;\n  outline: 2px solid var(--ink);\n  outline-offset: 3px;\n}\n\n.listas-cuenta {\n  margin: 0.2rem 0 0;\n  color: var(--soft);\n  font-size: 0.8rem;\n}\n\n.listas-tabla-wrap {\n  overflow-x: auto;\n}\n\n.listas-tabla {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.listas-tabla th {\n  padding: 0 0.4rem 0.4rem;\n  border-bottom: 1px solid var(--line);\n  color: var(--soft);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: left;\n}\n\n.listas-tabla th.listas-th-accion {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.listas-tabla td {\n  padding: 0.45rem 0.4rem 0.2rem;\n  vertical-align: bottom;\n  border: 0;\n}\n\n.listas-nadie {\n  padding: 0.85rem 0.4rem;\n  color: var(--soft);\n  font-size: 0.9rem;\n}\n\n.listas-formulario :deep(.listas-quiet.form-control) {\n  border-width: 0 0 2px;\n  border-style: solid;\n  border-color: var(--field);\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.listas-formulario :deep(.listas-quiet.form-control:hover) {\n  border-bottom-color: var(--ink);\n  background: transparent;\n}\n\n.listas-formulario :deep(.listas-quiet.form-control:focus) {\n  border-bottom-color: var(--ink);\n  background: #fff;\n  box-shadow: none;\n  outline: none;\n}\n\n.listas-formulario :deep(.listas-quiet.form-control:-webkit-autofill),\n.listas-formulario :deep(.listas-quiet.form-control:-webkit-autofill:hover) {\n  -webkit-text-fill-color: var(--ink);\n  caret-color: var(--ink);\n  box-shadow: 0 0 0 1000px #fff inset;\n  transition: background-color 9999s ease-out;\n}\n\n.listas-acciones {\n  display: flex;\n  gap: 0.4rem;\n  justify-content: flex-end;\n}\n\n.listas-anadir {\n  margin-top: 0.95rem;\n  padding-top: 0.9rem;\n  border-top: 1px solid var(--line);\n}\n\n.listas-formulario :deep(.listas-commit.btn) {\n  background: var(--ink);\n  border-color: var(--ink);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n}\n\n.listas-formulario :deep(.listas-commit.btn:hover:not(:disabled)) {\n  background: #121a2c;\n  border-color: #121a2c;\n  color: #fff;\n}\n\n.listas-formulario :deep(.listas-commit.btn:disabled) {\n  background: #c5cedb;\n  border-color: #c5cedb;\n  color: #fff;\n  opacity: 1;\n}\n\n.listas-formulario :deep(.listas-peligro.btn) {\n  background: transparent;\n  border-color: #e2c9d1;\n  border-radius: 4px;\n  color: var(--peligro);\n  font-weight: 600;\n}\n\n.listas-formulario :deep(.listas-peligro.btn:hover:not(:disabled)) {\n  background: var(--peligro);\n  border-color: var(--peligro);\n  color: #fff;\n}\n\n.listas-formulario :deep(.listas-peligro.btn:disabled) {\n  color: #c4a8b2;\n  border-color: #eadde1;\n  background: transparent;\n  opacity: 1;\n}\n\n.listas-formulario :deep(.listas-guardar.btn) {\n  background: transparent;\n  border-color: #c5cedb;\n  color: var(--ink);\n}\n\n.listas-formulario :deep(.listas-guardar.btn:hover:not(:disabled)) {\n  background: var(--ink);\n  border-color: var(--ink);\n  color: #fff;\n}\n\n.listas-formulario :deep(.listas-quitar.btn) {\n  border-color: transparent;\n  background: transparent;\n}\n\n.listas-formulario :deep(.listas-quitar.btn:hover:not(:disabled)) {\n  background: var(--peligro);\n  border-color: var(--peligro);\n  color: #fff;\n}\n\n.listas-formulario :deep(.btn:focus-visible) {\n  outline: 2px solid var(--ink);\n  outline-offset: 2px;\n}\n\n@media (max-width: 760px) {\n  .listas-page {\n    padding-top: 0.85rem;\n    background: #fff;\n  }\n\n  .listas-sheet {\n    padding: 0.95rem 0.85rem 0.9rem;\n  }\n\n  .listas-title {\n    font-size: 1.7rem;\n  }\n\n  .listas-alta-grid,\n  .listas-alta-grid.con-origen,\n  .listas-anadir-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .listas-alta-accion :deep(.btn),\n  .listas-anadir-accion :deep(.btn) {\n    width: 100%;\n  }\n\n  .listas-roster-head {\n    flex-direction: column;\n  }\n\n  .listas-formulario :deep(.listas-nombre-lista.form-control) {\n    font-size: 1.35rem;\n  }\n\n  .listas-tabla thead {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  .listas-tabla td[data-label]::before {\n    content: attr(data-label);\n    display: block;\n    margin-bottom: 0.15rem;\n    color: var(--soft);\n    font-size: 0.75rem;\n    font-weight: 600;\n  }\n\n  .listas-tabla,\n  .listas-tabla tbody,\n  .listas-tabla tr,\n  .listas-tabla td {\n    display: block;\n    width: 100%;\n  }\n\n  .listas-tabla tr {\n    padding: 0.35rem 0 0.5rem;\n    border-bottom: 1px solid var(--line);\n  }\n\n  .listas-tabla td {\n    border-bottom: 0;\n    padding: 0.2rem 0;\n  }\n\n  .listas-acciones {\n    justify-content: flex-start;\n    padding-top: 0.35rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .listas-alta-panel,\n  .listas-alta-panel.abierta,\n  .listas-alta-toggle,\n  .listas-alta-toggle-icono,\n  .listas-formulario :deep(.form-control),\n  .listas-formulario :deep(.btn) {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
